var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-8 pa-8",
      attrs: { "data-qa": "appointment_sidebar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "text-h6 text--text",
          attrs: { "data-qa": "appointment_sidebar_title" },
        },
        [_vm._v("\n    " + _vm._s(_setup.title) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column gr-6" }, [
        _setup.calendarDataStore.editableCalendarTitle
          ? _c("div", { staticClass: "d-flex flex gc-6" }, [
              _c(
                "div",
                {
                  staticClass: "text-body-1 text-secondary--text",
                  style: { flex: "0 0 88px" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.t("Время", _setup.options)) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-body-1 text--text",
                  attrs: { "data-qa": "appointment_sidebar_date" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.calendarDataStore.editableCalendarTitle) +
                      "\n      "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex gc-6" }, [
          _c(
            "div",
            {
              staticClass: "text-body-1 text-secondary--text",
              style: { flex: "0 0 88px" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_setup.t("Адрес", _setup.options)) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-body-1 text--text",
              attrs: { "data-qa": "appointment_sidebar_address" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_setup.lpuDataStore.lpuData.address) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _setup.appointmentDataStore.appointmentRegistrationTypes.isDirect &&
        (!_setup.appointmentDataStore.isAnyTelemed ||
          _setup.calendarDataStore.isCalendarDateSelected)
          ? _c(
              "div",
              { staticClass: "d-flex flex-column gr-1" },
              [
                _setup.appointmentDataStore.isAnyTelemed
                  ? [
                      _setup.calendarDataStore.isCalendarDateSelected
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "text-h5 text--text",
                                attrs: {
                                  "data-qa":
                                    "appointment_sidebar_telemed_price",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _setup.doctorDataStore.workplacePriceText
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-body-1 text-secondary--text",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _setup.t(
                                        _setup.priceSubtitle,
                                        _setup.options
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ]
                  : [
                      _setup.doctorDataStore.selectedWorkplace
                        .isFreeWithTreatment
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-center gc-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-h5 text-success--text",
                                  attrs: {
                                    "data-qa":
                                      "appointment_sidebar_free_appointment",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _setup.t("Бесплатно", _setup.options)
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass:
                                  "ui-icon-tag-discount text-success--text",
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-body-1 text-secondary--text text-decoration-line-through ml-2",
                                  attrs: {
                                    "data-qa": "appointment_sidebar_full_price",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _setup.doctorDataStore
                                          .workplacePriceText
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _setup.isClubPriceVisible
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-center gc-1" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-h5 error--text",
                                  attrs: {
                                    "data-qa": "appointment_sidebar_club_price",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.clubPrice) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-body-1 text-secondary--text text-decoration-line-through",
                                  attrs: {
                                    "data-qa": "appointment_sidebar_full_price",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _setup.doctorDataStore
                                          .workplacePriceText
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "text-h5 text--text",
                              attrs: {
                                "data-qa": "appointment_sidebar_full_price",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _setup.doctorDataStore.workplacePriceText
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-body-1 text-secondary--text" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _setup.t(_setup.priceSubtitle, _setup.options)
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
              ],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }